import { AloftDate, RevisionType } from '@aloft/toolkit-shared';

import { OrderTag } from '../modules/orderManagement/components/OrderTable/types.ts';

export const processOrderTags = ({
  isCompleted,
  dueDate,
  revisionType,
  isMock,
  isEscalated,
}: {
  dueDate?: AloftDate | null;
  isCompleted: boolean;
  revisionType?: RevisionType;
  isMock: boolean;
  isEscalated: boolean;
}): OrderTag[] => {
  const tags: OrderTag[] = [];
  const now = AloftDate.today();
  if (!isMock && dueDate && dueDate.compare(now) < 0 && !isCompleted) {
    tags.push(OrderTag.Overdue);
  }

  if (revisionType === 'rov') tags.push(OrderTag.ROV);
  else if (revisionType === 'revision') tags.push(OrderTag.Revision);

  if (isMock) tags.push(OrderTag.Mock);
  if (isEscalated) tags.push(OrderTag.Escalated);

  return tags;
};
